import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {CountAvailableRowsDirective} from './count-available-rows.directive';
import {EmptyRowsDirective} from './empty-rows.directive';
import {
    TableBodyEmptyRowDirective,
    TableBodyRowDirective,
    TableColumnDirective,
    TableComponent,
    TableHeaderRowDirective
} from './table';
import {TableColumnReorderModule} from './table/table-plugins/table-column-reorder';
import {
    TableColumnsResizerDisabledDirective,
    TableColumnsResizerModule
} from './table/table-plugins/table-columns-resizer';

@NgModule({
    imports: [
        CommonModule,
        TableColumnsResizerModule,
        TableColumnReorderModule
    ],
    declarations: [
        CountAvailableRowsDirective,
        EmptyRowsDirective,
        TableComponent,
        TableColumnDirective,
        TableBodyRowDirective,
        TableHeaderRowDirective,
        TableBodyEmptyRowDirective
    ],
    exports: [
        CountAvailableRowsDirective,
        EmptyRowsDirective,
        TableComponent,
        TableColumnDirective,
        TableBodyRowDirective,
        TableHeaderRowDirective,
        TableBodyEmptyRowDirective,
        TableColumnsResizerDisabledDirective
    ]
})
export class TablesModule {}
